// Solid-free helpers for the prices page (testable without a DOM or a server).
import type { PricingPlans, VehicleType } from "../shared/api";

export const TYPE_LABEL: Record<VehicleType, string> = {
  ebike: "Vélo électrique",
  bike: "Vélo",
  scooter: "Trottinette électrique",
  unknown: "Véhicule Pony",
};

const TYPES: VehicleType[] = ["ebike", "bike", "scooter"];

/** Pony plan ids are `City_type` (e.g. "Bordeaux_ebike"); anything else is "unknown". */
export function planVehicleType(planId: string): VehicleType {
  const cut = planId.lastIndexOf("_");
  if (cut <= 0) return "unknown";
  const t = planId.slice(cut + 1) as VehicleType;
  return TYPES.includes(t) ? t : "unknown";
}

export interface PricingRow {
  id: string;
  vehicle: string;
  city?: string;
  label: string;
}

/** One row per GBFS plan, sorted by city then vehicle type. */
export function pricingRows(plans: PricingPlans): PricingRow[] {
  return Object.entries(plans)
    .map(([id, p]) => {
      const type = planVehicleType(id);
      const city = type === "unknown" ? undefined : id.slice(0, id.lastIndexOf("_"));
      return { id, vehicle: TYPE_LABEL[type], ...(city && { city }), label: p.label };
    })
    .sort((a, b) => (a.city ?? "").localeCompare(b.city ?? "") || a.id.localeCompare(b.id));
}
